import { FC } from 'react';

import { NavLink, useLocation } from 'react-router-dom';

import { useGetProgressData } from 'hooks/useGetProgressData';

import styles from './GlobalNavigation.module.scss';

/**
 * グローバルナビゲーションコンポーネント
 *
 * @component
 * @example
 * return (
 *   <GlobalNavigation />
 * )
 */
export const GlobalNavigation: FC = () => {
  // 現在のルートの位置を取得します
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const phaseParam = queryParams.get('phase');
  const onboardingPhases = ['story', 'profile', 'walkthrough'];
  const isOnboarding = onboardingPhases.includes(phaseParam || '');
  const isTutorial = phaseParam === 'tutorial';

  // Redux StoreからユーザーのonBoarding状態と外部ウェブサイトのURLを取得します
  const { data } = useGetProgressData();
  // const { website } = useSelector((state: RootState) => state.external);

  /**
   * ナビゲーションメニューのリストアイテム
   * 各アイテムは、id、リンク、ラベルの3つのプロパティを持つオブジェクトです
   */
  const menuList: {
    id: string;
    link: string;
    label: string;
  }[] = [
    {
      id: 'home',
      link: '/home',
      label: 'ホーム',
    },
    {
      id: 'area',
      link: '/area',
      label: '探索エリア',
    },
    {
      id: 'card',
      link: '/card',
      label: 'カード',
    },
    {
      id: 'prizes',
      link: '/prizes',
      label: '賞品',
    },
    {
      id: 'menu',
      link: '/menu',
      label: 'メニュー',
    },
  ];

  if (
    location.pathname === '/' ||
    location.pathname.startsWith('/story') ||
    location.pathname === '/play' ||
    location.pathname === '/ending' ||
    location.pathname === '/reward/failure' ||
    location.pathname === '/redirect' ||
    location.pathname.includes('/rank-up') ||
    location.pathname.includes('halfway') ||
    location.pathname.includes('almost') ||
    location.pathname.includes('perfect') ||
    location.pathname.includes('/answer-result') ||
    isOnboarding
  ) {
    return <></>;
  }

  return (
    <nav
      data-on-boarding={isTutorial || data?.isOnboardingCompleted ? undefined : true}
      aria-hidden={
        new RegExp(`guide/onsite-complete`, 'g').test(location.pathname) ? 'true' : undefined
      }
      className={styles.nav}
    >
      <ul className={styles.list}>
        {menuList.map(menu => (
          <li className={styles.item} key={menu.id}>
            <NavLink
              to={menu.link}
              className={(): string => {
                let className = styles.link;
                const isCategoryActive =
                  menu.id === 'home'
                    ? location.pathname === '/home'
                    : new RegExp(`^${menu.link}`, 'g').test(location.pathname);
                if (isCategoryActive) className += ` ${styles['--current']}`;
                return className;
              }}
            >
              <img className={styles.icon} src={require(`images/icon/${menu.id}.svg`)} alt="" />
              <img
                className={styles.iconCurrent}
                src={require(`images/icon/${menu.id}_current.svg`)}
                alt=""
              />
              <span className={styles.label}>{menu.label}</span>
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
};
